// Lazy-loaded components for code splitting
import { lazy } from 'react';

// Admin components (only loaded when needed)
export const ImageGeneration = lazy(() => import('./pages/ImageGeneration'));
export const ImageEnhancement = lazy(() => import('./pages/ImageEnhancement'));
